// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1ZfTy","header":"ReportDetails_header__TzmCf","title":"ReportDetails_title__2tUp7","left":"ReportDetails_left__3kDSL"};